<template>
  <div class="main-content">
    <div class="row mb-3">
      <div class="col-md-3 mt-2">
        <label for="userSelect">Usuário:</label>
        <v-select
          id="userSelect"
          v-model="filters.user_id"
          :options="users"
          :reduce="(user) => user.id"
          label="name"
          placeholder="Todos os usuários"
          :clearable="true"
        />
      </div>

      <div class="col-md-3 mt-2">
        <label for="centralSelect">Agência:</label>
        <v-select
          id="centralSelect"
          v-model="filters.central_id"
          :options="centrals"
          :reduce="(central) => central.id"
          label="fantasy_name"
          placeholder="Todas as agências"
          :clearable="true"
        />
      </div>

      <div class="col-md-3 mt-2">
        <label>Data Inicial:</label>
        <input type="date" class="form-control" v-model="filters.start_date" />
      </div>

      <div class="col-md-3 mt-2">
        <label>Data Final:</label>
        <input type="date" class="form-control" v-model="filters.end_date" />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-12">
        <button class="btn btn-primary" @click="getLogAccess">Filtrar</button>
        <button class="btn btn-secondary ml-2" @click="clearFilters">
          Limpar Filtros
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card p-1">
          <div class="table-responsive">
            <table class="table table-bordered table-hover table-sm">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Usuário</th>
                  <th>Data e hora do LOG</th>
                  <th>IP de acesso</th>
                  <th>Retorno</th>
                  <!-- <th>Navegador</th> -->
                  <th>Mensagem</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="log in log_access" :key="log.id">
                  <td>{{ log.id }}</td>
                  <td>
                    {{ log.user ? log.user.name : "Não informado" }}
                  </td>
                  <td>{{ log.attempted_at_f }}</td>
                  <td>
                    {{ log.ip_address }}
                  </td>
                  <td>{{ log.success ? "Sucesso" : "Falha" }}</td>
                  <!-- <td>{{ log.user_agent }}</td> -->
                  <td>{{ log.message }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            class="col-md-6 mt-1 mx-auto d-flex justify-content-center align-items-center"
          >
            <pagination
              :records="total"
              :options="options"
              :per-page="15"
              @paginate="getLogAccess"
            ></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Pagination } from "vue-pagination-2";
import vSelect from "vue-select";
import {
  BLink,
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
  BButton,
  BModal,
} from "bootstrap-vue";

export default {
  data() {
    return {
      filters: {
        user_id: null,
        central_id: null,
        start_date: null,
        end_date: null,
      },
      log_access: [],
      users: [],
      centrals: [],
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
        chunk: 4,
        chunksNavigation: "fixed",
      },
      total: 0,
      page: 1,
      pages: [],
    };
  },
  components: {
    Pagination,
    vSelect,
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    BButton,
    BModal,
  },
  methods: {
    getLogAccess(page) {
      const self = this;
      self.page = page || 1;

      const api = self.$store.state.api + "log_access_index?page=" + self.page;

      self.$loading(true);
      axios
        .post(api, self.filters)
        .then((response) => {
          self.log_access = response.data.data;
          self.total = response.data.total;

          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },

    getUsers() {
      const self = this;
      const api = self.$store.state.api + "users?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.users = response.data.data.sort((a, b) =>
            a.name.localeCompare(b.name)
          );
        })
        .catch((error) => {
          self.$message(null, error.response?.data ?? error, "error");
        });
    },

    getCentrals() {
      const self = this;
      const api = self.$store.state.api + "centrals?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.centrals = response.data.data.sort((a, b) =>
            a.fantasy_name.localeCompare(b.fantasy_name)
          );
        })
        .catch((error) => {
          self.$message(null, error.response?.data ?? error, "error");
        });
    },

    clearFilters() {
      this.filters = {
        user_id: null,
        central_id: null,
        start_date: null,
        end_date: null,
      };
      this.getLogAccess();
    },
  },
  mounted() {
    this.getLogAccess();
    this.getUsers();
    this.getCentrals();
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.main-content {
  padding: 20px;
}

.table th,
.table td {
  text-align: center;
}
</style>
